import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import constants from "~/style/constants"
import FormError from "~/components/Form/ErrorText"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  text-align: left;
  background: white;
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  outline: none;
  height: 70px;
  width: 100%;
  padding-left: 20px;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  caret-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};
  border-radius: 4px;

  @media (max-width: 768px) {
    height: 56px;
    font-size: 0.9rem;
    padding-left: 16px;
  }

  @media (max-width: 480px) {
    height: 48px;
    font-size: 0.85rem;
  }
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  changeDOBString: all.store.trafficLookup.changeDOBString,
  DOBString: all.store.trafficLookup.DOBString,
}))
@observer
class DOBInput extends Component {
  handleDOBString = (event) => {
    const { value } = event.target
    this.props.changeDOBString(value)
  }

  render() {
    const dateErrorHandler = this.props.validateDisplayMessage("DOBString")
    return (
      <Wrap>
        <Input
          placeholder="MM/DD/YYYY"
          onChange={this.handleDOBString}
          value={this.props.DOBString}
          error={dateErrorHandler}
          type="tel"
        />
        <FormError error={dateErrorHandler} />
      </Wrap>
    )
  }
}

export default DOBInput
